import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		init: false,
		deliveryTime: null,
		deliveryUpdate: null,
	},
	getters: {
		deliveryTime(state) {
			return state.deliveryTime;
		},
		deliveryUpdate(state) {
			return state.deliveryUpdate;
		},
	},
	mutations: {
		SET_DELIVERYTIME(state, deliveryTime) {
			state.deliveryTime = deliveryTime;
		},
		SET_DELIVERYUPDATE(state, deliveryUpdate) {
			state.deliveryUpdate = deliveryUpdate;
		},
		SET_INIT(state, init) {
			state.init = init;
		},
		CLEAR_STORE(state) {
			state.init = false;
			state.deliveryTime = null;
			state.deliveryUpdate = null;
		},
	},
	actions: {
		updateDeliveryTimes({commit}, deliveryTimeSet) {
			return new Promise((resolve, reject) => {
				const toApi = {
					delivery_code: deliveryTimeSet,
				};
				apiClient.post('products/deliverytimes/update', toApi).then(res => {
					commit('SET_DELIVERYTIME', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})

			})
		},
		getDeliveryStatus({commit}) {
			return new Promise((resolve, reject) => {
				apiClient.get('products/deliverytimes/update/get').then(res => {
					commit('SET_DELIVERYUPDATE', res.data);
					commit('SET_INIT', true);
					resolve();
				}).catch(err => {
					reject(err);
				})
			})
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
